import React from 'react';
import PropTypes from 'prop-types';
import styles from './PageIntro.css';

const PageIntro = ({ children }) => {
  return (
    <div className={styles.intro}>{children}</div>
  );
};

PageIntro.propTypes = {
  children: PropTypes.node.isRequired,
};

export default PageIntro;
